



import Page from '../PostSales/sale/teskManage.vue'
export default {
  name: 'teskManageODM',
  components: { Page },
}
